import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=b85ef9c8&scoped=true&"
import script from "./batch.vue?vue&type=script&lang=ts&"
export * from "./batch.vue?vue&type=script&lang=ts&"
import style0 from "./batch.vue?vue&type=style&index=0&id=b85ef9c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85ef9c8",
  null
  
)

export default component.exports